import {nanoid} from 'nanoid';

import {CustomProperty} from 'common/types/reports/query';
import {getOwnAttr} from 'common/util';

export const INLINE_CUSTOM_PROPERTY_ID_PREFIX = `$temp-`;

export function isPersistedCustomProperty(customPropertyId) {
  return customPropertyId && !customPropertyId.toString().startsWith(INLINE_CUSTOM_PROPERTY_ID_PREFIX);
}

export function isInlineCustomProperty(customPropertyId) {
  return customPropertyId && customPropertyId.toString().startsWith(INLINE_CUSTOM_PROPERTY_ID_PREFIX);
}

export function isBehavioralCustomProperty(property: CustomProperty) {
  return !!getOwnAttr(property, `behavior`);
}

export function getInlineCustomPropertyId(customPropertyId) {
  return customPropertyId || `${INLINE_CUSTOM_PROPERTY_ID_PREFIX}${nanoid()}`;
}
